export enum ECatalogStatusTypes {
    REQUESTED = "REQUESTED",
    COLLECTING = "COLLECTING",
    COLLECTED = "COLLECTED",
    GENERATING = "GENERATING",
    GENERATED = "GENERATED",
    UPLOADED = "UPLOADED", // Available
    SENT = "SENT", // Available
    DELIVERED = "DELIVERED", // Available / not used?
    FAILED = "FAILED", // not used
    AVAILABLE = "AVAILABLE",
}

export type ECatalogStatusType =
    | ECatalogStatusTypes.REQUESTED
    | ECatalogStatusTypes.COLLECTING
    | ECatalogStatusTypes.COLLECTED
    | ECatalogStatusTypes.GENERATING
    | ECatalogStatusTypes.GENERATED
    | ECatalogStatusTypes.UPLOADED
    | ECatalogStatusTypes.SENT
    | ECatalogStatusTypes.DELIVERED
    | ECatalogStatusTypes.FAILED
    | ECatalogStatusTypes.AVAILABLE;

export interface ECatalogStatus {
    /* Process status type */
    type: ECatalogStatusType;
    /* Localized status message */
    text: string;
}

export interface ECatalogItem {
    /* Unique identifier of the return entry */
    fileName: string;
    /* Current process status */
    status: ECatalogStatus;
    /* Date when the return process was created */
    dateOfRequest: string;
    /* Who did create the return process */
    availability: string;
    /* URL of the eCatalog file to be downloaded */
    downloadLink: string;
}

export interface ECatalogResponse {
    /* API endpoint form requesting further results */
    nextPage?: string | null;
    /* The total number of results */
    totalCount: number;
    /** the HTML of the button call to action to be added to the page */
    buttonHTML: string;
    /* The format of the date to be displayed (as per day.js standards) */
    timeFormat: string;
    /* The result items */
    items: ECatalogItem[];
    /** messages to be displayed to the user when there is no data */
    messages?: {
        noDataHeadline: string;
        noDataText: string;
    };
}
